export default "__VITE_ASSET__4f0d6668__"